export default __webpack_public_path__ + "static/media/num-5.58cfafd4.png";